import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=33a98ac9&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./menu.vue?vue&type=style&index=1&id=33a98ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a98ac9",
  null
  
)

export default component.exports